var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prev-next"},[_c('prev-button',_vm._g({staticClass:"prev"},_vm.$listeners)),_c('submit-button',_vm._b({class:['next', ...(_vm.stepNum ? [`submit-step-${_vm.stepNum}`] : [])],attrs:{"loading":_vm.loading}},'submit-button',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }